<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    
        <mat-form-field appearance="outline" style="width: 100%">
          <textarea [(ngModel)]="msg" matInput #userinput spellcheck="false" readonly style="height: 100px; line-height: 1.3;"></textarea>
        </mat-form-field>

        <button mat-flat-button color="accent" *ngIf="copied" style="width: 125px;
        height: 50px; float: right;">  <mat-icon style="margin-right: 5px;" class="material-icons-round" [inline]="true"
        >done</mat-icon
      >Copied
      </button>
        <button
        *ngIf="!copied"
        mat-button 
        style="border: 1px solid #b48700; width: 125px;
        height: 50px; float: right"
        (click)="copyInputMessage(userinput)"
      >
        Copy
      </button>
  
      <!-- <textarea type="text" [(ngModel)]="msg" #userinput></textarea> -->
      <!-- <a href="javascript:void(0)" (click)="copyInputMessage(userinput)">
        <span id="link-copy">Copy Link</span>
      </a> -->
  </mat-dialog-content>
  